import { createAsyncThunk } from "@reduxjs/toolkit";
import { loadingActions } from "../LoaderSlice";
import { modalActions } from "../ModalSlice";
import { JEDI_HR_URL } from "../../constants";
import axiosClient from "../../utils/axiosClient";
import axios from "axios";

export const getAllSeperationReportees = createAsyncThunk(
  "seperation/get_reportees",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside getAllSeperationReportees : ", payload);

    const baseURL = "https://" + JEDI_HR_URL;

    const path = "/get_reportees";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      dispatch(loadingActions.setLoading(false));
      console.log("getAllSeperationReportees response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error : " +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          })
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error getAllSeperationReportees : ", error.message);

      dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        })
      );
      return rejectWithValue(error);
    }
  }
);
export const getSeperatonRequestList = createAsyncThunk(
  "seperation/is_separation",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside getSeperatonRequestList : ", payload);

    const baseURL = "https://" + JEDI_HR_URL;

    const path = "/is_separation";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      dispatch(loadingActions.setLoading(false));
      console.log("getSeperatonRequestList response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error : " +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          })
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error getSeperatonRequestList : ", error.message);

      dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        })
      );
      return rejectWithValue(error);
    }
  }
);
export const submitSeperation = createAsyncThunk(
  "seperation/separation_api",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside submitSeperation : ", payload);

    const baseURL = "https://" + JEDI_HR_URL;

    const path = "/separation_api";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      dispatch(loadingActions.setLoading(false));
      console.log("submitSeperation response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error : " +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          })
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error submitSeperation : ", error.message);

      dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        })
      );
      return rejectWithValue(error);
    }
  }
);
export const revokeSeperation = createAsyncThunk(
  "seperation/revoke_api",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside revokeSeperation : ", payload);

    const baseURL = "https://" + JEDI_HR_URL;

    const path = "/revoke_api";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      dispatch(loadingActions.setLoading(false));
      console.log("revokeSeperation response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error : " +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          })
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error revokeSeperation : ", error.message);

      dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        })
      );
      return rejectWithValue(error);
    }
  }
);
export const summaryView = createAsyncThunk(
  "seperation/summary_view",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside summaryView : ", payload);

    const baseURL = "https://" + JEDI_HR_URL;

    const path = "/summary_view";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      dispatch(loadingActions.setLoading(false));
      console.log("summaryView response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error : " +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          })
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error summaryView : ", error.message);

      dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        })
      );
      return rejectWithValue(error);
    }
  }
);
export const uploadFileWithPresignedUrl = createAsyncThunk(
  "seperation/generate_presigned_url",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside uploadFileWithPresignedUrl : ", payload);

    const baseURL = "https://" + JEDI_HR_URL;

    const path = "/generate_presigned_url";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, {
        employee_id: payload.employee_id,
        file_name: payload.file.name,
        key: payload.key,
      });

      dispatch(loadingActions.setLoading(false));
      console.log("uploadFileWithPresignedUrl response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error : " +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          })
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message
        );
      }

      const fileUploadData = new FormData();
      Object.keys(response?.data?.presigned_url?.fields).forEach((key) => {
        fileUploadData.append(key, response?.data?.presigned_url.fields[key]);
      });
      fileUploadData.append("file", payload.file);
      const fileUploadResponse = await axios.post(
        response?.data?.presigned_url.url,
        fileUploadData
      );

      if (fileUploadResponse.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message: "Error : " + fileUploadResponse?.data?.error_message,
            status: "error",
            state: true,
          })
        );
        return rejectWithValue(
          fileUploadResponse?.data?.error_message ||
            fileUploadResponse?.data?.message
        );
      }

      return {
        key: payload.key,
        presignedUrlResponse: response?.data?.presigned_url,
        response: fileUploadResponse.data,
      };
    } catch (error) {
      console.log("Error :  ", error.message);

      dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        })
      );
      return rejectWithValue(error);
    }
  }
);
export const downloadBulkSeperationTemplate = createAsyncThunk(
  "seperation/download_template",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside donwload bulk seperation : ", payload);

    const baseURL = "https://" + JEDI_HR_URL;

    const path = "/download_template";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      dispatch(loadingActions.setLoading(false));
      console.log("donwload bulk seperation response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error : " +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          })
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error revokeSeperation : ", error.message);

      dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        })
      );
      return rejectWithValue(error);
    }
  }
);
export const submitExitInterview = createAsyncThunk(
  "seperation/exit_interview",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside submit exit interview : ", payload);

    const baseURL = "https://" + JEDI_HR_URL;

    const path = "/exit_interview";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      dispatch(loadingActions.setLoading(false));
      console.log("submit exit interview response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error : " +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          })
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error revokeSeperation : ", error.message);

      dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        })
      );
      return rejectWithValue(error);
    }
  }
);
export const changeLastWorkingDay = createAsyncThunk(
  "seperation/change_last_working_day",
  async (payload, { dispatch, rejectWithValue }) => {
    dispatch(loadingActions.setLoading(true));

    const baseURL = "https://" + JEDI_HR_URL;
    const path = "/change_last_working_day";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);
      dispatch(loadingActions.setLoading(false));

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message: response?.data?.error_message || response?.data?.message,
            status: "error",
            state: true,
          })
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message
        );
      }
      dispatch(
        modalActions.setErrorModal({
          message: response?.data?.message,
          status: "success",
          state: true,
        })
      );
      return response.data;
    } catch (error) {
      dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        })
      );
      return rejectWithValue(error);
    }
  }
);
export const getNoticePeriod = createAsyncThunk(
  "seperation/get_notice_period",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside get notice period : ", payload);

    const baseURL = "https://" + JEDI_HR_URL;

    const path = "/get_notice_period";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      dispatch(loadingActions.setLoading(false));
      console.log("get notice period response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error : " +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          })
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error revokeSeperation : ", error.message);

      dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        })
      );
      return rejectWithValue(error);
    }
  }
);
